import * as yupValidations from "./yupValidations";

const validations = {
  yupValidations,
};

export default validations;
